<template>
    <div class="flex justify-center">
        <div class="btn-group flex items-center ">
            <button class="btn btn-primary btn-xs" :disabled="pageNumber===0" @click="previousPage">
                «
            </button>
            <div class="px-3 text-lg font-bold h-12 flex items-center">
                {{ pageNumber + 1 }}
            </div>
            <button
                class="btn btn-primary btn-xs"
                :disabled="pageNumber===(totalPages - 1) || totalPages === 0"
                @click="nextPage"
            >
                »
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import {PAGE_CHANGED} from '@/types/transaction/TransactionEvent'

const emit = defineEmits([PAGE_CHANGED])

const props = defineProps({
    pageNumber: {type: Number, default: 0},
    totalPages: {type: Number, default: 0}
})

const previousPage = () => {
    emit(PAGE_CHANGED, props.pageNumber - 1)
}
const nextPage = () => {
    emit(PAGE_CHANGED, props.pageNumber + 1)
}

</script>

<style>

</style>